import {
  reportDefinitionsApi,
  type ReportDefinitionPage,
  type ReportDefinitionSend,
  type ReportDefinitionSendDelivery,
  type ReportDefinitionSummary,
} from './api';
import type { ReportDefinitionsBoard } from './report-definitions-board.svelte';
import { ReportSendOverview } from './report-send-overview';

/**
 * Os contatos de um envio, uma página por vez. Quando o envio teve falha, abre só nas falhas: com 300 contatos,
 * o que pede ação vem primeiro. Trocar de página ou de filtro rápido não deixa a resposta atrasada tomar o lugar;
 * a página que falha não apaga a que está na tela.
 */
export class ReportSendDeliveries {
  page = $state<ReportDefinitionPage<ReportDefinitionSendDelivery> | null>(null);
  /** A página que não carregou, para tentar de novo; nula quando a última carregou. */
  failedPage = $state<number | null>(null);
  onlyFailed = $state(false);
  private latestRequest = 0;

  constructor(private readonly opened: { board: ReportDefinitionsBoard; definition: ReportDefinitionSummary; send: ReportDefinitionSend }) {
    this.onlyFailed = new ReportSendOverview(opened.send).hasFailures;
  }

  get failedBeforeAnyPage(): boolean {
    return this.page === null && this.failedPage !== null;
  }

  async load(page = 1): Promise<void> {
    const request = ++this.latestRequest;
    try {
      const loaded = await reportDefinitionsApi.deliveries({
        definition: this.opened.definition,
        reportId: this.opened.send.reportId,
        onlyFailed: this.onlyFailed,
        page,
      });
      if (request !== this.latestRequest) return;
      this.page = loaded;
      this.failedPage = null;
    } catch (err) {
      if (request !== this.latestRequest) return;
      this.failedPage = page;
      this.opened.board.fail(err);
    }
  }

  /** O envio fechado não espera mais resposta: a que chegar depois não avisa erro de uma lista que ninguém vê. */
  abandon(): void {
    this.latestRequest++;
  }

  async toggleOnlyFailed(): Promise<void> {
    this.onlyFailed = !this.onlyFailed;
    await this.load(1);
  }
}
